export default __webpack_public_path__ + "static/media/4.ee02575b.jpg";